import React from 'react'
import './testimonials.css'
import AVTR1 from '../../assets/ale__ssiio.jpg'
import AVTR2 from '../../assets/ericvalcourt.jpg'
import AVTR3 from '../../assets/scott_durbin.jpg'
import AVTR4 from '../../assets/Untitled-1.jpg'


// import Swiper core and required modules
import {Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar: AVTR1,
    name: 'Alessio',
    review: 'Great Design, good service! Thank you chhamza for your super service, did a very good job with a very clean design. Communication was perfect with you, looking foreward to work with you again'
  },
  {
    avatar: AVTR2,
    name: 'Eric Valcourt',
    review: 'Great job at taking my brief and making it happen. Would definitely work with the designer again.'
  },
  {
    avatar: AVTR3,
    name: 'Scott Durbin',
    review: 'Great seller and excellent communication and understanding of my goals and wants. Very fast at delivering the order and making revisions as needed. Will most definitely use again for my future projects. Thank you!'
  },
  {
    avatar: AVTR4,
    name: 'Jota Pablo',
    review: 'Great Design, good service! Thank you chhamza for your super service, did a very good job with a very clean design. Communication was perfect with you, looking foreward to work with you again'
  }
]

const Testimonials = () => {
  return (
    <section id='testimonials'>
      <h5>Review from Clients</h5>
      <h2>Testimonials</h2>

      <Swiper className="container testimonials__container"
      // install Swiper modules
      modules={[Pagination]}
      spaceBetween={40}
      slidesPerView={1}
      pagination={{ clickable: true }}
      >
        {
          data.map(({avatar, name, review}, index) => {
            return(
              <SwiperSlide key={index} className="testimonial">
          <div className="client__avatar">
            <img src={avatar} alt =''/>
          </div>

          <h5>{name}</h5>
          <small className='client__review'>{review}</small>
        </SwiperSlide>
            )
          })
        }       
      </Swiper>
    </section>
  )
}

export default Testimonials